import { InjectionToken, Signal } from '@angular/core';
import { User } from '@firebase/auth';

export interface AuthService {
  user: Signal<User | null>;
  idToken: Signal<string | null>;

  isLoggedIn(): Signal<boolean>;

  signInWithGoogle(): Promise<boolean>;

  signInWithMagicLink(email: string): Promise<boolean>;

  completeMagicLinkSignIn(emailLink: string): Promise<boolean>;

  signOut(): Promise<boolean>;
}

export const AUTH_SERVICE = new InjectionToken<AuthService>('AUTH_SERVICE');
